<template>
  <v-container fluid>
    <v-app-bar app elevate-on-scroll>
      <v-btn icon @click="$router.go(-1)">
        <v-icon dark>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>Register</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-row justify="center" class="text-center">
      <v-col cols="12" sm="6" md="4">
        <v-card elevation="0" outlined color="transparent">
          <v-card-text>
            <v-form id="registration-form" ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="firstName"
                :rules="[rules.required]"
                label="First name *"
                required
              ></v-text-field>
              <v-text-field
                v-model="lastName"
                :rules="[rules.required]"
                label="Last name *"
                required
              ></v-text-field>
              <v-text-field
                v-model="email"
                :rules="[rules.required, rules.emailValid]"
                label="E-mail *"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                :rules="[rules.required, rules.min]"
                :type="'password'"
                name="password"
                label="Password *"
                hint="At least 8 characters"
                counter
              ></v-text-field>
              <v-checkbox
                v-model="agreed"
                :rules="[rules.agree]"
                required
                hide-details
                 class="mb-5"
              >
              <template v-slot:label>
                <div>
                I agree to the <a @click.stop href="https://vnfbay.com/terms/" target="_blank">Terms and Conditions</a>
                and <a @click.stop href="https://vnfbay.com/privacy/" target="_blank">Privacy Policy</a>
                </div>
              </template>
              </v-checkbox>
            </v-form>
            <v-btn
                color="primary"
                @click="submit"
                :disabled="loading"
                :loading="loading"
                form="registration-form"
                class="mt-5"
                >
                submit
              </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="error" align="center" justify="center">
      <v-col cols="12" sm="6">
        <app-alert @dismissed="onDismissed" :title="error.title" :text="error.message"></app-alert>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="mb-10">
      <v-col cols="12" sm="6">
          <div class="text-center">Already have an account?<v-btn text color="primary" :to="'/login'">Log in</v-btn></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      rules: {
        required: v => !!v || 'Required.',
        agree: v => !!v || 'You must agree to continue!',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailValid: v => /.+@.+/.test(v) || 'E-mail must be valid'
      },
      organisation: '',
      firstName: '',
      lastName: '',
      email: '',
      agreed: false,
      password: '',
      confirmPassword: ''
    }
  },
  mounted () {
    this.$store.dispatch('clearError')
  },
  computed: {
    comparePasswords () {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : true
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('auth/signup', {
          organisation: this.organisation,
          agreed: this.agreed,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password
        })
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError', null, { root: true })
    }
  }
}
</script>
